<template>
  <div>
    <b-row class="pr-3" v-if="selectable">
      <b-col>
        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.events"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.events"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.familyFND"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.kids"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.pets"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.pets"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.smoking"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.smoking"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.disabFND"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.disabilities"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>

        <b-row>
          <b-col class="text-right pr-0" text-align="right">
            <b-form-group
              id="fieldsetHorizontal"
              horizontal
              breakpoint="lg"
              :label="i18n_local.sublease"
              :label-cols="6"
              label-for="inputHorizontal"
              align="left"
              class="moow-info-txt"
            >
              <toggle-button
                v-model="rulesLocal.sublease"
                :height="35"
                :width="70"
                color="#4ABDAC"
                style="float:right"
                :disabled="readonly"
                :labels="{checked: 'YES', unchecked: 'NO'}"
              />
            </b-form-group>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row class="mb-3 mt-3" v-else>
      <!-- {{rules}} -->
      <b-col
        md="6"
        cols="12"
        class="text-left"
        v-for="(value, key, index) in rules"
        :key="value+key+index"
      >
        <md-list>
          <md-list-item>
            <md-icon>{{getRuleIcon(key, value)}}</md-icon>
            <div class="md-list-item-text">
              <span>{{getRuleDisplayValue(key, value)}}</span>
            </div>
          </md-list-item>
        </md-list>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  props: {
    rules: {
      type: Object,
      required: false
    },
    readonly: {
      type: Boolean,
      default: false
    },
    selectable: {
      type: Boolean,
      default: true
    }
  },
  data: function() {
    return {
      rulesLocal: {
        events: false,
        pets: false,
        kids: false,
        smoking: false,
        disabilities: false
      },
    };
  },
  watch: {
    rules: function(val, oldVal) {
      if (val) this.setHouseRules(val);
    }
  },
  computed: {
    ...mapGetters("internationalizationModule", ["i18n_local"])
  },
  created() {
    this.rules ? this.setHouseRules(this.rules) : void 0;
  },
  methods: {
    setHouseRules(rules) {
      if (rules) {
        this.rulesLocal = rules;
      }
    },
    getRules() {
      return this.rulesLocal;
    },
    getRuleDisplayValue(key, value) {
      var result;
      switch (key) {
        case "events":
          value ? (result = "Events allowed") : (result = "No events");
          break;
        case "smoking":
          value ? (result = "Smoking allowed") : (result = "No smoking");
          break;
        case "disabilities":
          value
            ? (result = "Disability Friendly")
            : (result = "Not accessible");
          break;
        case "pets":
          value ? (result = "Pets Allowed") : (result = "No pets");
          break;
        case "kids":
          value
            ? (result = "Suitable for kids")
            : (result = "Not suitable for kids");
          break;
        case "sublease":
          value ? (result = "sublease allowed") : (result = "No sublease");
          break;
      }
      return result;
    },
    getRuleIcon(key, value) {
      var result;
      switch (key) {
        case "events":
          value ? (result = "party_mode") : (result = "clear");
          break;
        case "smoking":
          value ? (result = "smoking_rooms") : (result = "smoke_free");
          break;
        case "disabilities":
          value ? (result = "accessible") : (result = "accessible");
          break;
        case "pets":
          value ? (result = "pets") : (result = "clear");
          break;
        case "kids":
          value ? (result = "child_friendly") : (result = "error");
          break;
        case "sublease":
          value ? (result = "chrome_reader_mode") : (result = "clear");
          break;
      }
      return result;
    }
  }
};
</script>
<style scoped>
@import "../../assets/styles/global.css";
@import "../../assets/styles/listing-preview.css";
</style>



// WEBPACK FOOTER //
// src/components/listingComponents/houseRulesSelector.vue